module.exports = __webpack_public_path__ + "static/media/60_to_Zero_in_10_Seconds.7d33cd58.mp3";